


import React from 'react';

const ProgressModal = ({ percentCompleted }: { percentCompleted: number }) => {
  return (
    <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft:'100px',
      marginTop:'60px',
      padding: '0px',
      textAlign: 'center',
    }}
  >
    <p style={{ marginBottom: '20px' }}>Aguarde, estamos baixando o documento...</p>
    
    <div style={{ width: '100%', backgroundColor: '#e0e0e0', borderRadius: '4px', marginBottom: '10px' }}>
      <div
        style={{
          width: `${percentCompleted}%`,
          height: '10px',
          backgroundColor: '#3b82f6',
          borderRadius: '4px',
          transition: 'width 0.3s ease',
        }}
      />
    </div>
    
    <p style={{ fontWeight: 'bold' }}>{percentCompleted}%</p>
  </div>
  );
};

export default ProgressModal;